import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['icon'];
  static values = {
    processing: { type: Boolean, default: false },
  };

  connect() {}

  toggleLike() {
    if (this.processingValue) return;

    this.processingValue = true;

    const iconElement = this.iconTarget;
    const isLiked = iconElement.classList.contains('fill-current');

    if (isLiked) {
      iconElement.classList.remove('fill-current', 'text-red-500');
      iconElement.classList.add(
        'stroke-current',
        'stroke-[1.5]',
        'text-[#1E1E27]'
      );
    } else {
      iconElement.classList.remove(
        'stroke-current',
        'stroke-[1.5]',
        'text-[#1E1E27]'
      );
      iconElement.classList.add('fill-current', 'text-red-500');
    }

    setTimeout(() => {
      this.processingValue = false;
    }, 500);
  }
}
